module.exports = __webpack_public_path__ + "media/dietz.f671ae6d.mp4";